import { Badge, Menu } from 'antd';
import { VFC } from 'react';
import { LogoutOutlined, SettingOutlined } from '@ant-design/icons';
import { useStore as useInventorizeStore } from 'routes/inventorize_meter/useStore';
import { useStore as useInstallStore } from 'routes/installation/useStore';
import { useOnlineStatus } from 'hooks/useOnlineStatus';
import { useReplaceMeterStore } from 'routes/meter_replacement/useStore';
import { FormattedMessage } from 'react-intl';
import { useLogoutModalVisibilityStore, useSettingsModalVisibilityStore, useSyncModalStore } from '../../Modal/store';
import { SyncMenu as messages } from '../messages';
import { useSessionStore } from '../../../store/session';

const commonSelectItemStyle = {
  display: 'flex',
  height: '48px',
  width: '250px',
};

export const InventoryMenu: VFC = () => {
  const { isOnline } = useOnlineStatus();
  const { isAuthenticated } = useSessionStore();
  const { setState: setSyncModalState } = useSyncModalStore();
  const { setVisibility: setLogoutModalVisibility } = useLogoutModalVisibilityStore();
  const { setVisibility: setSettingsModalVisibility } = useSettingsModalVisibilityStore();
  const { queuedMetersCount: queuedInstallMetersCount } = useInstallStore();
  const { queuedMetersCount: queuedInventorizeMetersCount } = useInventorizeStore();
  const { queuedMetersCount: queuedReplaceMetersCount } = useReplaceMeterStore();

  const handleSyncInstallClick = () => {
    setSyncModalState(true, 'install');
  };

  const handleSyncInventoryClick = () => {
    setSyncModalState(true, 'pasport');
  };

  const handleSyncReplaceClick = () => {
    setSyncModalState(true, 'replace');
  };

  const handleSettingsClick = () => {
    setSettingsModalVisibility(true);
  };

  const handleLogoutClick = () => {
    setLogoutModalVisibility(true);
  };

  const itemsProps = [
    ...(isAuthenticated
      ? [
          {
            key: 'install',
            onClick: handleSyncInstallClick,
            disabled: !isOnline || queuedInstallMetersCount === 0,
            icon: (
              <Badge
                showZero
                className="sync-button"
                count={queuedInstallMetersCount}
                overflowCount={50}
                size="small"
                style={{ cursor: 'pointer' }}
              />
            ),
            style: commonSelectItemStyle,
            label: <FormattedMessage {...messages.synchronisationOfInstallations} />,
          },
          {
            key: 'pasport',
            onClick: handleSyncInventoryClick,
            disabled: !isOnline || queuedInventorizeMetersCount === 0,
            icon: (
              <Badge
                showZero
                className="sync-button"
                count={queuedInventorizeMetersCount}
                overflowCount={50}
                size="small"
                style={{ cursor: 'pointer' }}
              />
            ),
            style: commonSelectItemStyle,
            label: <FormattedMessage {...messages.synchronisationOfPasports} />,
          },
          {
            key: 'replace',
            onClick: handleSyncReplaceClick,
            disabled: !isOnline || queuedReplaceMetersCount === 0,
            icon: (
              <Badge
                showZero
                className="sync-button"
                count={queuedReplaceMetersCount}
                overflowCount={50}
                size="small"
                style={{ cursor: 'pointer' }}
              />
            ),
            style: commonSelectItemStyle,
            label: <FormattedMessage {...messages.synchronisationOfExchanges} />,
          },
        ]
      : []),
    {
      key: 'settings',
      onClick: handleSettingsClick,
      icon: <SettingOutlined />,
      style: commonSelectItemStyle,
      label: <FormattedMessage {...messages.settings} />,
    },
    ...(isAuthenticated
      ? [
          {
            key: 'logout',
            onClick: handleLogoutClick,
            icon: <LogoutOutlined />,
            style: commonSelectItemStyle,
            label: <FormattedMessage {...messages.logout} />,
          },
        ]
      : []),
  ];

  return <Menu items={itemsProps} />;
};
